import script from "./InvoiceTable.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceTable.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceTable.vue?vue&type=style&index=0&id=4c55af8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c55af8d"]])

export default __exports__